import { ErrorAction } from "../Types/redux.types";

export const handleApiError = (
  error: unknown): Error => {
  return error instanceof Error
    ? error
    : new Error(String(error));
};
export const handleActionError = <T extends string>(

  error: unknown,
  errorActionType: T

): ErrorAction & { type: T } => {

  const normalizedError: Error = handleApiError(error);

  return {
    type: errorActionType,
    payload: normalizedError,
    error: true,
  };
};
